document.addEventListener("DOMContentLoaded", function() {
    $('.header-hamburger').on('click', function() {
        $(this).toggleClass('open');
        $('.mobile-menu').toggleClass('open');
        $('html').toggleClass('mobile-menu-open');
    });

    $('.mobile-menu__menu .header-menu__url-wrap').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.has-chidlren').toggleClass('open');
    });
});
document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth >= 1199) {
        const dropdowns = document.querySelectorAll('.mega-menu-dropdown');
        let maxHeight = 0;

        dropdowns.forEach(menu => {
            menu.style.height = 'auto';
            const height = menu.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        dropdowns.forEach(menu => {
            menu.style.height = maxHeight + 'px';
        });
    }
});